import React from 'react';
import { useNavigate } from 'react-router-dom';
import Language_i18 from '../js/useNationalLanguage.jsx';

// Menu configuration enriched with English ('en') and Vietnamese ('vi')
const menuConfig = [
    {
        id: 1,
        route: "/shop/e-commerce/partner/orders",
        img: "https://tecom.pro/img/icon/okokokok.png",
        title: { vi: "Mua Coins từ các bạn trong app", en: "Buy coins from other users in the app" },
        desc: { vi: "🔥 Coins users đã cày 💸 khuyến mãi ngập tràn! 💥 →", en: "🔥 Users have mined coins 💸 tons of promotions! 💥 →" },
        textSize: "lg",
        imgSize: { h: 8, w: 8 },
        descClass: "text-sm",
    },
    {
        id: 2,
        route: "/shop/main/menu?webappmode=showadview",
        img: "https://tecom.pro/img/icon/fight.jpeg",
        title: { vi: "Cày Coins miễn phí", en: "Mine coins for free" },
        desc: { vi: "Không thay việc truyền thống, nhưng thu nhập thụ động →", en: "Doesn't replace traditional work, but passive income →" },
        textSize: "lg",
        imgSize: { h: 7, w: 7 },
        descClass: "text-sm",
    },
    {
        id: 3,
        route: "/shop/donate/acb",
        img: "https://hust.media/img/icon/bank_logo.png",
        title: { vi: "Donate ngân hàng ấn đây nhé", en: "Top up via bank, click here" },
        desc: { vi: "Tối thiểu 100 coins →", en: "Minimum 100 coins →" },
        textSize: "lg",
        imgSize: { h: 7, w: 7 },
        descClass: "",
    },
    // {
    //     id: 4,
    //     route: "/shop/donate/mb",
    //     img: "https://hust.media/img/icon/mb-bank-logo.jpg",
    //     title: { vi: "Nạp qua ngân hàng ấn đây nhé", en: "Top up via MB Bank, click here" },
    //     desc: { vi: "Tối thiểu 100xu, Chấp nhận chuyển từ ngân hàng khác →", en: "Minimum 100 coins, accepts transfers from other banks →" },
    //     textSize: "lg",
    //     imgSize: { h: 7, w: 7 },
    //     descClass: "",
    // },
    // {
    //     id: 5,
    //     route: "/shop/momoidcode",
    //     img: "https://hust.media/img/icon/momo_logo.png",
    //     title: { vi: "Cộng Coins từ mã giao dịch momo", en: "Credit coins via MoMo transaction code" },
    //     desc: { vi: "Tối thiểu 100 Coins, tối đa 30k Coins →", en: "Minimum 100 coins, up to 30k coins →" },
    //     textSize: "base",
    //     imgSize: { h: 7, w: 7 },
    //     descClass: "text-xs",
    // },
    // {
    //     id: 6,
    //     route: "/shop/donate/momo",
    //     img: "https://hust.media/img/icon/momo_logo.png",
    //     title: { vi: "Nạp Coins qua MoMo ✓", en: "Top up coins via MoMo ✓" },
    //     desc: { vi: "Tối thiểu 5005 vnd →", en: "Minimum 5005 VND →" },
    //     textSize: "lg",
    //     imgSize: { h: 7, w: 7 },
    //     descClass: "",
    // },
    {
        id: 7,
        route: "/shop/doithe",
        img: "https://hust.media/img/icon/cards_logo.png",
        title: { vi: "Donate thẻ cào ấn đây nhé", en: "Top up via scratch card, click here" },
        desc: { vi: "Tối thiểu 10k →", en: "Minimum 10k →" },
        textSize: "lg",
        imgSize: { h: 8, w: 8 },
        descClass: "text-xs",
    },
    // Uncomment and enrich the following as needed:
    // {
    //   id: 8,
    //   external: true,
    //   href: "/payeer?=mienphihust.media",
    //   img: "https://hust.media/img/icon/bit_logo.png",
    //   title: { vi: "Nạp qua Payeer", en: "Top up via Payeer" },
    //   desc: { vi: "Chuyển qua ví Payeer hoặc blockchain Bitcoin, Ethereum, Litecoin", en: "Transfer to Payeer wallet or via Bitcoin, Ethereum, Litecoin" },
    //   textSize: "lg",
    //   imgSize: { h: 12, w: 12 },
    //   descClass: "",
    // },
    // {
    //   id: 9,
    //   external: true,
    //   href: "https://hust.media/shop/content/blog_posts/freefltiktok/24",
    //   img: "https://hust.media/img/icon/YouTube_full-color_icon_(2017).svg.webp",
    //   title: { vi: "Nạp qua đăng clip", en: "Top up by posting videos" },
    //   desc: { vi: "Miễn phí", en: "Free" },
    //   textSize: "lg",
    //   imgSize: { h: 12, w: 12 },
    //   descClass: "",
    // },
    {
        id: 10,
        route: "/shop/e-commerce/seller/orders",
        img: "https://media.lordicon.com/icons/wired/gradient/39-cog.gif",
        title: {
            "vi": "Rút tiền qua bán coins",
            "en": "Withdraw via selling coins"
        },
        desc: { vi: "Tối thiểu 8k coins →", en: "Minimum 8k coins →" },
        textSize: "lg",
        imgSize: { h: 7, w: 7 },
        descClass: "",
    },
    // ...etc.
];
const Homehust = () => {
    const { lang } = Language_i18();
    const navigate = useNavigate();

    const switch_router = link => navigate(link);

    return (
        <div className="container-fluid">
            <div className="row mt-4">
                <div className="grid gap-3 grid-cols-2 md:grid-cols-3 md:mx-1">
                    {menuConfig.map(item => {
                        const language = lang === "vi" || lang === "en" ? lang : "en";
                        const content = (
                            <div className="max-w-7xl mx-2 py-2 mb-2" key={item.id}>
                                <div className="relative group">
                                    <div className="absolute -inset-1 bg-gradient-to-r from-purple-600 to-pink-600 rounded-lg blur opacity-25 group-hover:opacity-100 transition duration-1000 group-hover:duration-200" />
                                    <div className="relative px-3 py-3 bg-gradient-to-r from-blue-100 to-pink-200 hover:from-pink-400 hover:to-yellow-300 ring-1 ring-gray-900/5 rounded-2xl leading-none flex items-top justify-start space-x-3">
                                        <div className="space-y-2">
                                            <p className={`text-${item.textSize} text-slate-1000`}>
                                                <img src={item.img} className={`h-${item.imgSize.h} w-${item.imgSize.w} mr-2 cananh`} alt={item.title[language]} />
                                                {item.title[language]}
                                            </p>
                                            <div className={`block text-indigo-400 group-hover:text-slate-800 transition duration-200 ${item.descClass}`}>{item.desc[language]}</div>
                                            <span className="absolute rounded-2xl inset-x-0 bottom-0 h-2 bg-gradient-to-r from-green-300 via-blue-500 to-purple-600" />
                                        </div>
                                    </div>
                                </div>
                            </div>
                        );

                        return item.external ? (
                            <a href={item.href} target="_blank" rel="noopener noreferrer" key={item.id}>
                                {content}
                            </a>
                        ) : (
                            <div role="button" onClick={() => switch_router(item.route)} key={item.id}>
                                {content}
                            </div>
                        );
                    })}
                </div>
            </div>
        </div>
    );
}
export default Homehust;
